import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactPlayer from 'react-player';
import { throttle } from 'lodash';
import getRemBase from 'propel/getRemBase';

const backgroundVideoComponent = () => {
	const backgroundVideoBlocks = [];
	let backgroundVideos = [];

	const loadVideos = () => {
		backgroundVideos = document.querySelectorAll(
			'.acf-block__background-video-wrapper'
		);

		if (backgroundVideos.length) {
			backgroundVideos.forEach((backgroundVideo) => {
				if (backgroundVideo.hasAttribute('data-video-url')) {
					const videoURL =
						backgroundVideo.getAttribute('data-video-url');
					const videoLoopAttribute =
						backgroundVideo.getAttribute('data-video-loop');
					const hideMobileBackgroundVideo =
						backgroundVideo.getAttribute('data-hide-mobile');
					const root = createRoot(backgroundVideo);
					const parentBlock = backgroundVideo.closest('.acf-block');
					const state = { isLoading: false, isLoaded: false };
					let videoLoop = true;

					if (
						'false' === videoLoopAttribute ||
						'0' === videoLoopAttribute
					) {
						videoLoop = false;
					}

					if (parentBlock) {
						backgroundVideoBlocks.push(parentBlock);

						parentBlock.style.setProperty(
							'--blockHeight',
							`${parentBlock.offsetHeight / getRemBase()}rem`
						);
					}

					const renderVideo = () => {
						root.render(
							<ReactPlayer
								className="acf-block__background-video"
								url={videoURL}
								playing
								loop={videoLoop}
								muted
								width="100%"
								height="100%"
								onReady={(player) => {
									videoLoaded(player, state);
								}}
							/>
						);
					};

					if (hideMobileBackgroundVideo && window.innerWidth < 992) {
						window.addEventListener(
							'resize',
							throttle(() => {
								if (
									!state.isLoading &&
									!state.isLoaded &&
									window.innerWidth >= 992
								) {
									state.isLoading = true;
									renderVideo();
								}
							}, 100)
						);
					} else {
						renderVideo();
					}
				}
			});
		}
	};

	const videoLoaded = (player, stateRef = null) => {
		player.wrapper.classList.add('loaded');

		if (stateRef) {
			stateRef.isLoaded = true;
			stateRef.isLoading = false;
		}
	};

	const setBackgroundVideoSize = () => {
		if (backgroundVideoBlocks.length) {
			backgroundVideoBlocks.forEach((backgroundVideoBlock) => {
				backgroundVideoBlock.style.setProperty(
					'--blockHeight',
					`${backgroundVideoBlock.offsetHeight / getRemBase()}rem`
				);
			});
		}
	};

	loadVideos();

	window.addEventListener('load', setBackgroundVideoSize);
};

backgroundVideoComponent();

export default backgroundVideoComponent;
